import React, {useContext} from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { UserContext } from "..";
import { useState } from "react";
import fancybox from "component/Fancybox/Fancybox";
import { EditExperience } from "component/EditExperience";
import update from "immutability-helper";
import { useEffect } from "react";
import api from "api";
import _ from "lodash";
import ThreeDots from "component/ThreeDots";
import ComponentExperience from "component/Experience";
import { createBrowserHistory, parsePath } from "history";
import PaginationWrapper from "component/Pagination";
import { popinfo } from "component/Fancybox/Fancybox";
import { ComponentConfigAbout } from "component/ConfigAbout";
import { PageCredential } from "component/PageCredential";

const PageProfileBio = connect(stateMap)(props => {
    const currentUserContext = useContext(UserContext);
    const [experiences, setExperiences]         = useState(false);
    const [countExperience, setCountExperience] = useState(false);
    const [bioUser, setBioUser]         = useState(currentUserContext.profile);
    
    let history                                 = createBrowserHistory();

    const EditingExperience = (Experience) => {
        if(Experience)
        {
            const ExperienceForm = fancybox(
                <>
                    <BlockHeader title="Edit Experience" desc="Add your interesting experience in the field below" className="mb-sm"/>
                    <EditExperience experience={Experience} onSubmit={experience => {
                        setExperiences(update(experiences, {
                            $splice : [[
                                _.findIndex(experiences, {ExpID : experience.ExpID})
                                ,1
                                ,experience
                            ]]
                        }));

                        ExperienceForm.close();
                    }}/>
                </>
            );
        }
        else
        {
            const ExperienceForm = fancybox(
                <>
                    <BlockHeader title="Add Experience" desc="Add your interesting experience in the field below" className="mb-sm"/>
                    <EditExperience onSubmit={experience => {
                        setExperiences(update(experiences, {
                            $unshift : [experience]
                        }));

                        ExperienceForm.close();
                    }}/>
                </>
            );
        }
    }

    const DeleteExperience = (Experience) => {
        let RemoveExp = popinfo('loading', 'Deleting Experience', '')

        api('/Profile/Experience', 'delete', {
            exp_id : Experience.ExpID
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                RemoveExp.close();

                setExperiences(update(experiences, {
                    $splice : [[
                        _.findIndex(experiences, {ExpID : Experience.ExpID})
                        ,1
                    ]]
                }));
            })     
            .catch(error => {
                popinfo('error', 'Removing Experience', error, {}, RemoveExp)
            }) 
    }

    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');

    const [parameter, setParameter]             = useState({
        paged           : parseInt(queryString.get('paged') || 1)  
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 20
    });

    useEffect(() => {
        if(!props.auth.user)
        {
            return;
        }

        var DataToLoad = [
            api('/Profile/Experience', 'get', _.assign({ user_id : props.auth.user.UserID }, parameter), 'Bearer ' + props.auth.token)
        ];

        if(parameter.paged === 1)
        {
            DataToLoad.push(
                api('/Profile/Experience', 'get', _.assign({user_id : props.auth.user.UserID, get_total : 1 }, parameter), 'Bearer ' + props.auth.token)
            );
        }

        Promise.all(DataToLoad)


            .then(response => {
                setExperiences(response[0].experience);
    
                if(parameter.paged === 1)
                {
                    setCountExperience( parseInt(response[1].experience) );
                }
            })

        
    }, [props.auth.user, parameter]);

    
    return (
        <div className="profile-user-bio">
            <PageCredential title={`Profile`}/>
            <div className="container" style={{display: 'none'}}>
                <BlockHeader title="About"/>
                <div className="wp-content mt-md w-800" dangerouslySetInnerHTML={{__html : 
                    bioUser ? bioUser.UserAbout : ''
                }}/>
                <br />
                <ComponentConfigAbout profile={bioUser} onChanged={(about) => {
                    
                    setBioUser(
                        update(bioUser, {
                            UserAbout : {
                                $set : about
                            }
                        })
                    );
                }}/>
            </div>
            <div className="container">
                <div className="w-800 mx-auto relative">
                    <BlockHeader title="Experience"/>
                    <ul className="experiences-list ">
                        {
                            experiences !== false && experiences.map(experience => (
                                <li className="experience" key={experience.ExpID}>
                                    <ComponentExperience experience={experience}>
                                        <ThreeDots>
                                            <button onClick={ e => {
                                                e.preventDefault();

                                                EditingExperience(experience);
                                            }}>update</button>
                                            <button onClick={ e => {
                                                e.preventDefault();

                                                var ask = window.confirm('Are You Sure ?');

                                                if(!ask)
                                                {
                                                    return;
                                                }

                                                DeleteExperience(experience);
                                            }}>delete</button>
                                        </ThreeDots>
                                    </ComponentExperience>
                                </li>
                            ))
                        }
                        {
                            experiences === false &&
                            <li className="experience" key="experience-skeleton">
                                <div className="wrapper">
                                    <span className="skeleton"></span>
                                </div>
                            </li>
                        }
                    </ul>
                    <PaginationWrapper
                        className="mt-4"
                        activePage={parameter.paged}
                        itemsCountPerPage={parameter.posts_per_page}
                        totalItemsCount={countExperience}
                        pageRangeDisplayed={5}
                        onChange={(pagenumber) => {
                            setParameter(update(parameter, { paged : {$set : pagenumber } }))
                        }}
                    />
                    {
                        experiences !== false && 
                        <button className="btn btn-reverse btn-small add-profile-item-button" onClick={(e) => {
                            e.preventDefault();

                            EditingExperience();

                        }}>Add Experience</button>
                    }
                </div>
            </div>
        </div>
    )
});

export default PageProfileBio;